import { useMutation } from "react-query";
import { createCrisisPlan, updateCrisisPlan } from "api/clinicalManagement";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertCrisisPlan = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload, isNew = false }: { clientId: number; payload: Record<string, any>; isNew?: boolean }) =>
      isNew ? createCrisisPlan(clientId, payload) : updateCrisisPlan(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while saving the crisis plan.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    upsertCrisisPlanMutation: mutate,
    isUpsertCrisisPlanLoading: isLoading,
    ...rest,
  };
};

export default useUpsertCrisisPlan;
